export class BaseItemModel {}
